<!-- Overlay -->
<div *ngIf="userData != null && showCoachmark" class="coachmark-overlay"></div>

<!----header---->
<header class="header-hld">
  <!-- Fixed navbar -->
 
    <nav class="navbar navbar-expand-md b5containeradjust nav-cutom">
      <div class="container ">
        <a href="javascript:void(0)" title="DebtBusters-Client" class="logo-hld navbar-brand p-0"
          [routerLink]="userData!=null?['/portal/dashboard']:['/register']">
          <img src="../../assets/images/logoJM.png" alt="" width="192px"/>
        </a>

          <a class="navbar-toggler border-0 p-0" (click)="ToggleMobileMenuCoachmark(0)">
            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="25px"
              viewBox="0 0 512 512" width="25px">
              <g>
                <path
                  d="m464.883 64.267h-417.766c-25.98 0-47.117 21.136-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.013-21.137-47.149-47.117-47.149z"
                  data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                <path
                  d="m464.883 208.867h-417.766c-25.98 0-47.117 21.136-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.013-21.137-47.149-47.117-47.149z"
                  data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                <path
                  d="m464.883 353.467h-417.766c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.012-21.137-47.149-47.117-47.149z"
                  data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
              </g>
            </svg>
          </a>
          <div *ngIf="showCoachmark" class="coachmark-pulse d-block d-md-none">
            <div class="pulse-background"></div> <!-- New pulsing background layer -->
            <div class="coachmark-ring">
              <div class="coachmark-circle" >
                <a class="border-0 p-0" (click)="OpenNavbar()">
                  <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" enable-background="new 0 0 512 512" height="25px"
                    viewBox="0 0 512 512" width="25px">
                    <g>
                      <path
                        d="m464.883 64.267h-417.766c-25.98 0-47.117 21.136-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.013-21.137-47.149-47.117-47.149z"
                        data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                      <path
                        d="m464.883 208.867h-417.766c-25.98 0-47.117 21.136-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.013-21.137-47.149-47.117-47.149z"
                        data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                      <path
                        d="m464.883 353.467h-417.766c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.012-21.137-47.149-47.117-47.149z"
                        data-original="#000000" class="active-path" data-old_color="#000000" fill="#e59a2c" />
                    </g>
                  </svg>
                </a>
              </div>
              <div class="coachmark-tooltip">
                <h4>No need to stress</h4>
                <p>Exploring your offers doesn’t negatively impact your credit score.</p>
                <div class="coachmark-buttons">
                  <button id="btn_userJourney_close__coachMarkDashboard" name="btn_userJourney_close__coachMarkDashboard" class="dismiss-btn" (click)="ToggleCoachmark(0)">Dismiss</button>
                  <button id="btn_userJourney_offers_coachMarkDashboard" name="btn_userJourney_offers_coachMarkDashboard" class="view-btn" (click)="ToggleCoachmark(1)">View my offers</button>
                </div>
              </div>
            </div>
            <!-- Coachmark Text Tooltip -->
          
          </div>
          <div class=" navbar-collapse">
            <div class="ms-xl-5 ms-lg-3 d-flex w-100 column-reverse">

              <ul class="navbar-nav w-100 align-items-center custom-nav">
                <li *ngIf="userData!=null">
                  <a href="javascript:void(0)" id="dashboard-header" name="dashboard-header"  routerLinkActive="active-link" routerLink="/portal/dashboard" (click)="ToggleMobileMenuCoachmark(0)">Dashboard</a></li>
                    <!-- Investments unhide for release v6 -->
                    <li *ngIf="userData!=null"><a href="javascript:void(0)" id="account-header" name="account-header" routerLinkActive="active-link" routerLink="/portal/account" (click)="ToggleMobileMenuCoachmark(0)">Credit Report</a></li>
                  <li *ngIf="userData!=null"><a href="javascript:void(0)" id="products-header" name="products-header" routerLink="/portal/solutions"  routerLinkActive="active-link" (click)="ToggleMobileMenuCoachmark(1)">Offers</a>
                  <li *ngIf="userData != null" [ngStyle]="{ 'padding-left': showCoachmark ? '0.5rem' : '0', 'padding-right': showCoachmark ? '0.5rem' : '0' }" 
                   class="coachmark-container d-none d-md-block">
                    <div *ngIf="showCoachmark" class="coachmark-pulse">
                      <div class="pulse-background"></div> <!-- New pulsing background layer -->
                      <div class="coachmark-ring">
                        <div class="coachmark-circle">
                          <a href="javascript:void(0)" id="products-header" name="products-header" class="offers_class"    routerLinkActive="active-link" (click)="ToggleCoachmark(1)" >
                            Offers
                          </a>
                        </div>
                        <div class="coachmark-tooltip">
                          <h4>No need to stress</h4>
                          <p>Exploring your offers doesn’t negatively impact your credit score.</p>
                          <div class="coachmark-buttons">
                            <button id="btn_userJourney_close__coachMarkDashboard" name="btn_userJourney_close__coachMarkDashboard" class="dismiss-btn" (click)="ToggleCoachmark(0)">Dismiss</button>
                            <button id="btn_userJourney_offers_coachMarkDashboard" name="btn_userJourney_offers_coachMarkDashboard" class="view-btn" (click)="ToggleCoachmark(1)">View my offers</button>
                          </div>
                        </div>
                      </div>
                      <!-- Coachmark Text Tooltip -->
                      
                    </div>
                  </li>


                  <!-- <li *ngIf="userData!=null"><a href="javascript:void(0)"  routerLinkActive="active-link" routerLink="/portal/investments">Investments</a> -->
                <li *ngIf="userData!=null && UserPolicyDetails?.isDataAvailable"><a href="javascript:void(0)" routerLink="/portal/insurance" id="insurance-header" name="insurance-header"
                    routerLinkActive="active-link"  (click)="ToggleMobileMenuCoachmark(0)">Insurance</a>
                  <li *ngIf="userData!=null"><a href="javascript:void(0)" routerLink="/portal/news"  id="news-header" name="news-header"  routerLinkActive="active-link">Articles</a> 
                    <li *ngIf="userData!=null" class="d-md-none"><a id="profile-header" name="profile-header" href="javascript:void(0)"  routerLinkActive="active-link"  routerLink="/portal/profile" (click)="ToggleMobileMenuCoachmark(0)">Profile</a>



                    

                <li *ngIf="userData==null" class="navlinks"><a  id="register-header" href="javascript:void(0)"  routerLinkActive="active-link" routerLink="/register"
                    class="btn-border">Register</a></li>
                <li *ngIf="userData==null" class="navlinks"><a  id="login-header" href="javascript:void(0)"  routerLinkActive="active-link" (click)="checkLoginFired()"
                    class="btn-border">Login</a></li>

                <li *ngIf="userData!=null" class="drp-holder ms-auto d-md-block d-none">
                  <a
                    href="javascript:void(0)"
                    id="navbarDropdown"
                    class="nav-link dropdown-toggle"
                    role="button"
                    (click)="toggleDropdown($event)"
                    aria-expanded="false"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37">
                      <g id="Group_59" data-name="Group 59" transform="translate(-0.5)">
                        <path id="user-regular" d="M11.453,11.1c-1.048,0-1.552.584-3.272.584S5.96,11.1,4.908,11.1A4.91,4.91,0,0,0,0,16.011v.935A1.753,1.753,0,0,0,1.753,18.7H14.608a1.753,1.753,0,0,0,1.753-1.753v-.935A4.91,4.91,0,0,0,11.453,11.1Zm3.155,5.843H1.753v-.935a3.161,3.161,0,0,1,3.155-3.155,14.3,14.3,0,0,0,3.272.584,14.162,14.162,0,0,0,3.272-.584,3.161,3.161,0,0,1,3.155,3.155ZM8.181,10.518A5.259,5.259,0,1,0,2.922,5.259,5.26,5.26,0,0,0,8.181,10.518Zm0-8.765A3.506,3.506,0,1,1,4.675,5.259,3.512,3.512,0,0,1,8.181,1.753Z" transform="translate(10.906 8.479)" fill="#e59a2c"/>
                        <g id="Ellipse_106" data-name="Ellipse 106" transform="translate(0.5)" fill="none" stroke="#e59a2c" stroke-width="2">
                          <circle cx="18.5" cy="18.5" r="18.5" stroke="none"/>
                          <circle cx="18.5" cy="18.5" r="17.5" fill="none"/>
                        </g>
                      </g>
                    </svg>
                    <h5 class="user-name-txt">Hi {{userData.given_name}} <i _ngcontent-fba-c5=""
                        class="mnu-barrow-down"></i></h5>
                  </a>
                  <ul class="logprofile dropdown-menu " [class.show]="dropdownVisible" aria-labelledby="navbarDropdown">

                    <li><a href="javascript:void(0)" routerLink="/portal/profile" id="profile-header"  routerLinkActive="active-link" (click)="ToggleMobileMenuCoachmark(0)">Profile</a></li>
                    <li *ngIf="userData!=null"><a href="javascript:void(0)" routerLink="/portal/setting" id="settings-header" name="settings-header"  routerLinkActive="active-link" (click)="ToggleMobileMenuCoachmark(0)">Settings</a></li>
                    

                    <li><a href="javascript:void(0)" (click)="logout()" id="logout-header-browser" name="logout-header-browser">Logout
                        <svg class="logout-icon" viewBox="0 0 32 32">
                          <defs>
                            <style>
                              .logout-icon .cls-1 {
                                fill: none;
                                stroke: #666;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 2px;
                              }
                            </style>
                          </defs>
                          <g id="logout">
                            <line class="cls-1" x1="15.92" x2="28.92" y1="16" y2="16" />
                            <path
                              d="M23.93,25v3h-16V4h16V7h2V3a1,1,0,0,0-1-1h-18a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1h18a1,1,0,0,0,1-1V25Z" />
                            <line class="cls-1" x1="28.92" x2="24.92" y1="16" y2="20" />
                            <line class="cls-1" x1="28.92" x2="24.92" y1="16" y2="12" />
                            <line class="cls-1" x1="24.92" x2="24.92" y1="8.09" y2="6.09" />
                            <line class="cls-1" x1="24.92" x2="24.92" y1="26" y2="24" />
                          </g>
                        </svg>
                      </a></li>
                  </ul>
                </li>

                <li *ngIf="userData!=null" class="mobile-display" ><a href="javascript:void(0)"  routerLinkActive="active-link" id="settings-header-mobile"
                    routerLink="/portal/setting" (click)="ToggleCoachmark(0)">Settings</a></li>

                <li *ngIf="userData!=null" class="mobile-display"><a href="javascript:void(0)" id="logout_mob_header" (click)="logout()">Logout
                    <svg class="logout-icon" viewBox="0 0 32 32">
                      <defs>
                        <style>
                          .logout-icon .cls-1 {
                            fill: none;
                            stroke: #666;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-width: 2px;
                          }
                        </style>
                      </defs>
                      <g id="logout">
                        <line class="cls-1" x1="15.92" x2="28.92" y1="16" y2="16" />
                        <path
                          d="M23.93,25v3h-16V4h16V7h2V3a1,1,0,0,0-1-1h-18a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1h18a1,1,0,0,0,1-1V25Z" />
                        <line class="cls-1" x1="28.92" x2="24.92" y1="16" y2="20" />
                        <line class="cls-1" x1="28.92" x2="24.92" y1="16" y2="12" />
                        <line class="cls-1" x1="24.92" x2="24.92" y1="8.09" y2="6.09" />
                        <line class="cls-1" x1="24.92" x2="24.92" y1="26" y2="24" />
                      </g>
                    </svg>
                  </a></li>
              </ul>
            </div>
          </div>
      </div>
    </nav>
  
</header>


<ng-template #callbackConfirmationModel let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Free callback request</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')" 
      name="btn_callbackConfirmationModel_Closed" isCloseButton="true">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="callbackErrorMsg!=''" class="alert alert-danger" role="alert">
      {{callbackErrorMsg}}
    </div>
    <div *ngIf="callbackSuccessMsg!=''" class="alert alert-success" role="alert">
      {{callbackSuccessMsg}}
    </div>
    <div *ngIf="callbackSuccessMsg==''">Do you want a coach to call you now?</div>
  </div>
  <div class="modal-footer" *ngIf="callbackSuccessMsg==''">
    <button type="button" class="btn-border" (click)="modal.dismiss('No')">No</button>
    <button type="button" class="btn btn-primary" (click)="callback()">Yes</button>
  </div>
</ng-template>

<ng-template #LoginBackError let-modal>
  <div class="modal-header">
    <h4 class="modal-title backetitle">Navigation Warning</h4>
    </div>
    <div class="modal-body">
      <div>You have not completed your registration verification. If you leave now, you will not be able to continue this journey. You will have to speak to a coach. Are you sure you want to Leave?</div>
    </div>
    <div class="modal-footer backefooter">
      <button type="button" class="btn-border" (click)="stopNavigation()" name="btn_sequrityquestion_navigation_No">No</button>
      <button type="button" class="btn btn-primary" (click)="redirectLogin()" name="btn_sequrityquestion_navigation_Yes">Yes</button>
    </div>
  </ng-template>
